/* RESPONSIBLE TEAM: team-ai-agent */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type IntlService from 'embercom/services/intl';

class SimulationsRoute extends Route {
  @service appService: any;
  @service router: any;
  @service declare intl: IntlService;

  get titleToken(): string {
    return this.intl.t('ai-agent.sub-menu.simulations.title');
  }

  beforeModel() {
    // Redirect to Batch Test page if feature flag is disabled
    if (!this.appService.app.canUseSophisticatedTestingCentralisedPage) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.testing.index');
    }
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(SimulationsRoute);
